module.exports = __webpack_public_path__ + "static/media/obesidade.79ef00b6.png";